<template>
  <v-autocomplete
    v-model="VALORES_SELECIONADOS_COMPUTED"
    label="Status Produtos"
    outlined
    hide-details
    :items="itens"
    multiple
    small-chips
  >
    <template #prepend-item>
      <SysItemListaSelecionaTudo
        v-model="VALORES_SELECIONADOS_COMPUTED"
        :itens="itens"
        valor-chave="value"
      />

      <v-divider />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  model: {
    prop: 'modelValue',
    event: 'update:modelValue',
  }
}
</script>

<script setup>
import {computed} from "vue";
import SysItemListaSelecionaTudo from "@/components/utils/crud/SysItemListaSelecionaTudo.vue";

const props = defineProps({
  modelValue: Array,
});

const emit = defineEmits(['update:modelValue']);

const VALORES_SELECIONADOS_COMPUTED = computed({
  get: () => props.modelValue,
  set: valor => emit('update:modelValue', valor),
});

const itens = [
  { text: 'Ativos', value: 'A' },
  { text: 'Inativos', value: 'FL' },
];
</script>
